import {
  faCheck,
  faMicrophone,
  faPlus,
  faStar,
  faTag,
  faTrash,
  faUser,
} from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";

import {
  DSBadge,
  DSButton,
  DSCardWrapper,
  DSCheckbox,
  DSChip,
  DSCircularButton,
  DSDropdown,
  DSDropzone,
  DSInput,
  DSLinkButton,
  DSRichTextarea,
  DSTextarea,
  DSToggle,
} from "../molecules";

export const MoleculesSection = () => {
  // Dropdown state
  const [basicDropdownValue, setBasicDropdownValue] = useState<
    string | number | null
  >(null);
  const [searchDropdownValue, setSearchDropdownValue] = useState<
    string | number | null
  >(null);
  const [iconDropdownValue, setIconDropdownValue] = useState<
    string | number | null
  >(null);
  const [disabledDropdownValue, setDisabledDropdownValue] = useState<
    string | number | null
  >("option1");
  const [sectionsDropdownValue, setSectionsDropdownValue] = useState<
    string | number | null
  >(null);
  const [widthDropdownValue, setWidthDropdownValue] = useState<
    string | number | null
  >(null);

  // Textarea state
  const [textareaValue, setTextareaValue] = useState("");
  const [richTextareaValue, setRichTextareaValue] = useState("");

  // Chip state for filter examples
  const [dateFilterApplied, setDateFilterApplied] = useState(false);
  const [teamFilterApplied, setTeamFilterApplied] = useState(true);
  const [templateFilterApplied, setTemplateFilterApplied] =
    useState(false);

  // Dropzone state
  const [uploadProgress, setUploadProgress] = useState<
    number | undefined
  >();

  const dropdownOptions = [
    { label: "Option 1", value: "option1" },
    { label: "Option 2", value: "option2" },
    { label: "Option 3", value: "option3" },
    {
      label: "Option 4 (Disabled)",
      value: "option4",
      disabled: true,
    },
    { label: "Option 5", value: "option5" },
    { label: "Option 6", value: "option6" },
  ];

  const sectionsDropdownOptions = [
    {
      label: "Favorites",
      value: "favorites-header",
      isHeader: true,
      icon: faStar,
    },
    { label: "Apple", value: "apple" },
    { label: "Banana", value: "banana" },
    { label: "Vegetables", value: "veg-header", isHeader: true },
    { label: "Carrot", value: "carrot" },
    { label: "Broccoli", value: "broccoli" },
    { label: "Grains", value: "grains-header", isHeader: true },
    { label: "Rice", value: "rice" },
    { label: "Wheat", value: "wheat" },
  ];

  return (
    <>
      {/* Buttons Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Buttons</h2>

        <DSCardWrapper dataTestId="ds-test-buttons-card">
          {/* Primary Buttons */}
          <div className="mb-lg">
            <h3>Primary</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Large</p>
                <DSButton
                  dataTestId="ds-test-btn-primary-lg"
                  variant="primary"
                  size="lg"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Medium (default)</p>
                <DSButton
                  dataTestId="ds-test-btn-primary-md"
                  variant="primary"
                  size="md"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Small</p>
                <DSButton
                  dataTestId="ds-test-btn-primary-sm"
                  variant="primary"
                  size="sm"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>With Icon</p>
                <DSButton
                  dataTestId="ds-test-btn-primary-icon"
                  variant="primary"
                  size="lg"
                  icon={faCheck}
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Disabled</p>
                <DSButton
                  dataTestId="ds-test-btn-primary-disabled"
                  variant="primary"
                  size="lg"
                  disabled
                >
                  Button Text
                </DSButton>
              </div>
            </div>
          </div>

          {/* Secondary Buttons */}
          <div className="mb-lg">
            <h3>Secondary</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Large</p>
                <DSButton
                  dataTestId="ds-test-btn-secondary-lg"
                  variant="secondary"
                  size="lg"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Medium</p>
                <DSButton
                  dataTestId="ds-test-btn-secondary-md"
                  variant="secondary"
                  size="md"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Small</p>
                <DSButton
                  dataTestId="ds-test-btn-secondary-sm"
                  variant="secondary"
                  size="sm"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>With Icon</p>
                <DSButton
                  dataTestId="ds-test-btn-secondary-icon"
                  variant="secondary"
                  size="lg"
                  icon={faPlus}
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Disabled</p>
                <DSButton
                  dataTestId="ds-test-btn-secondary-disabled"
                  variant="secondary"
                  size="lg"
                  disabled
                >
                  Button Text
                </DSButton>
              </div>
            </div>
          </div>

          {/* Cancel Buttons */}
          <div>
            <h3>Cancel</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Large</p>
                <DSButton
                  dataTestId="ds-test-btn-cancel-lg"
                  variant="cancel"
                  size="lg"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Medium</p>
                <DSButton
                  dataTestId="ds-test-btn-cancel-md"
                  variant="cancel"
                  size="md"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Small</p>
                <DSButton
                  dataTestId="ds-test-btn-cancel-sm"
                  variant="cancel"
                  size="sm"
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>With Icon</p>
                <DSButton
                  dataTestId="ds-test-btn-cancel-icon"
                  variant="cancel"
                  size="lg"
                  icon={faTrash}
                >
                  Button Text
                </DSButton>
              </div>
              <div>
                <p>Disabled</p>
                <DSButton
                  dataTestId="ds-test-btn-cancel-disabled"
                  variant="cancel"
                  size="lg"
                  disabled
                >
                  Button Text
                </DSButton>
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Circular Buttons Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Circular Buttons</h2>

        <DSCardWrapper dataTestId="ds-test-circular-buttons-card">
          <div className="mb-lg">
            <h3>Sizes</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Extra Extra Large</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-xxl"
                  size="xxl"
                  icon={faMicrophone}
                />
              </div>
              <div>
                <p>Large</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-lg"
                  size="lg"
                  icon={faMicrophone}
                />
              </div>
              <div>
                <p>Medium (default)</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-md"
                  size="md"
                  icon={faMicrophone}
                />
              </div>
              <div>
                <p>Small</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-sm"
                  size="sm"
                  icon={faMicrophone}
                />
              </div>
            </div>
          </div>

          <div>
            <h3>Disabled</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Extra Extra Large</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-xxl-disabled"
                  size="xxl"
                  icon={faMicrophone}
                  disabled
                />
              </div>
              <div>
                <p>Large</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-lg-disabled"
                  size="lg"
                  icon={faMicrophone}
                  disabled
                />
              </div>
              <div>
                <p>Medium</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-md-disabled"
                  size="md"
                  icon={faMicrophone}
                  disabled
                />
              </div>
              <div>
                <p>Small</p>
                <DSCircularButton
                  dataTestId="ds-test-circular-btn-sm-disabled"
                  size="sm"
                  icon={faMicrophone}
                  disabled
                />
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Link Buttons Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Link Buttons</h2>

        <DSCardWrapper dataTestId="ds-test-link-buttons-card">
          {/* Brand Variant */}
          <div className="mb-lg">
            <h3>Brand (default)</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Default</p>
                <DSLinkButton dataTestId="ds-test-link-btn-brand">
                  Link Button
                </DSLinkButton>
              </div>
              <div>
                <p>With Icon</p>
                <DSLinkButton
                  dataTestId="ds-test-link-btn-brand-icon"
                  icon={faPlus}
                >
                  Add Item
                </DSLinkButton>
              </div>
              <div>
                <p>Disabled</p>
                <DSLinkButton
                  dataTestId="ds-test-link-btn-brand-disabled"
                  disabled
                >
                  Link Button
                </DSLinkButton>
              </div>
            </div>
          </div>

          {/* Danger Variant */}
          <div className="mb-lg">
            <h3>Danger</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Default</p>
                <DSLinkButton
                  dataTestId="ds-test-link-btn-danger"
                  variant="danger"
                >
                  Delete
                </DSLinkButton>
              </div>
              <div>
                <p>With Icon</p>
                <DSLinkButton
                  dataTestId="ds-test-link-btn-danger-icon"
                  variant="danger"
                  icon={faTrash}
                >
                  Delete Item
                </DSLinkButton>
              </div>
              <div>
                <p>Disabled</p>
                <DSLinkButton
                  dataTestId="ds-test-link-btn-danger-disabled"
                  variant="danger"
                  disabled
                >
                  Delete
                </DSLinkButton>
              </div>
            </div>
          </div>

          {/* Inline Usage */}
          <div>
            <h3>Inline Usage</h3>
            <p className="text-secondary mb-md">
              Link buttons can be used inline with text.
            </p>
            <p>
              Click{" "}
              <DSLinkButton
                dataTestId="ds-test-link-btn-inline"
                onClick={() => alert("Inline link clicked!")}
              >
                here
              </DSLinkButton>{" "}
              to learn more, or{" "}
              <DSLinkButton
                dataTestId="ds-test-link-btn-inline-danger"
                variant="danger"
                onClick={() => alert("Cancel clicked!")}
              >
                cancel
              </DSLinkButton>{" "}
              your action.
            </p>
          </div>
        </DSCardWrapper>
      </section>

      {/* Inputs Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Inputs</h2>

        <DSCardWrapper dataTestId="ds-test-inputs-card">
          {/* Basic Inputs */}
          <div className="mb-lg">
            <h3>Basic</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Default Size</p>
                <DSInput
                  dataTestId="ds-test-input-default"
                  placeholder="Placeholder"
                />
              </div>
              <div>
                <p>Large Size</p>
                <DSInput
                  dataTestId="ds-test-input-large"
                  size="md"
                  placeholder="Placeholder"
                />
              </div>
            </div>
          </div>

          {/* With Label */}
          <div className="mb-lg">
            <h3>With Label</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Default with Label</p>
                <DSInput
                  dataTestId="ds-test-input-label-default"
                  label="Label"
                  placeholder="Placeholder"
                />
              </div>
              <div>
                <p>Large with Label</p>
                <DSInput
                  dataTestId="ds-test-input-label-large"
                  size="md"
                  label="Label"
                  placeholder="Placeholder"
                />
              </div>
            </div>
          </div>

          {/* With Leading Icon */}
          <div className="mb-lg">
            <h3>With Leading Icon</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Default with Icon</p>
                <DSInput
                  dataTestId="ds-test-input-icon-default"
                  leadingIcon={faUser}
                  placeholder="Placeholder"
                />
              </div>
              <div>
                <p>Large with Icon</p>
                <DSInput
                  dataTestId="ds-test-input-icon-large"
                  size="md"
                  leadingIcon={faUser}
                  placeholder="Placeholder"
                />
              </div>
            </div>
          </div>

          {/* States */}
          <div>
            <h3>States</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Disabled</p>
                <DSInput
                  dataTestId="ds-test-input-disabled"
                  placeholder="Placeholder"
                  disabled
                  leadingIcon={faUser}
                />
              </div>
              <div>
                <p>With Error</p>
                <DSInput
                  dataTestId="ds-test-input-error"
                  placeholder="Placeholder"
                  error="This field is required"
                />
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Textareas Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Textareas</h2>

        <DSCardWrapper dataTestId="ds-test-textareas-card">
          {/* Basic Textareas */}
          <div className="mb-lg">
            <h3>Basic</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Small Size (default)</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-small"
                  placeholder="Enter your text..."
                  value={textareaValue}
                  onChange={(e) => setTextareaValue(e.target.value)}
                />
              </div>
              <div>
                <p>Medium Size</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-medium"
                  size="md"
                  placeholder="Enter your text..."
                />
              </div>
            </div>
          </div>

          {/* With Label */}
          <div className="mb-lg">
            <h3>With Label</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Small with Label</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-label-small"
                  label="Notes"
                  placeholder="Enter your notes..."
                />
              </div>
              <div>
                <p>Medium with Label</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-label-medium"
                  size="md"
                  label="Description"
                  placeholder="Enter description..."
                />
              </div>
            </div>
          </div>

          {/* States */}
          <div className="mb-lg">
            <h3>States</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Disabled</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-disabled"
                  placeholder="This is disabled"
                  disabled
                  value="Some existing text"
                />
              </div>
              <div>
                <p>With Error</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-error"
                  placeholder="Enter text..."
                  error="This field is required"
                />
              </div>
            </div>
          </div>

          {/* Row Configuration */}
          <div>
            <h3>Row Configuration</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg max-w-4xl">
              <div>
                <p>Min 2 Rows, Max 6 Rows</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-rows"
                  placeholder="Try typing multiple lines..."
                  minRows={2}
                  maxRows={6}
                  label="Auto-resize example"
                />
              </div>
              <div>
                <p>Min 5 Rows (larger start)</p>
                <DSTextarea
                  dataTestId="ds-test-textarea-min-rows"
                  placeholder="Starts with more space..."
                  minRows={5}
                />
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Rich Textareas Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Rich Textareas</h2>

        <DSCardWrapper
          variant="ghost"
          dataTestId="ds-test-rich-textareas-card"
        >
          <p className="text-secondary mb-md">
            Rich text editor with markdown shortcuts and optional
            toolbar. Try typing{" "}
            <code className="bg-secondary px-xs rounded-minimal">
              **bold**
            </code>
            ,{" "}
            <code className="bg-secondary px-xs rounded-minimal">
              *italic*
            </code>
            , or use the toolbar buttons for formatting.
          </p>

          {/* With Toolbar */}
          <div className="mb-lg">
            <h3>With Toolbar</h3>
            <div className="grid grid-cols-1 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Full Toolbar with Formatting Options</p>
                <DSRichTextarea
                  dataTestId="ds-test-rich-textarea-toolbar"
                  placeholder="Start typing or use the toolbar..."
                  label="Notes"
                  onChange={() => {}}
                >
                  <DSRichTextarea.Toolbar textareaTitle="Field Title" />
                  <DSRichTextarea.Input
                    minHeight="200px"
                    maxHeight="500px"
                  />
                </DSRichTextarea>
              </div>
            </div>
          </div>

          {/* Basic Rich Textareas */}
          <div className="mb-lg">
            <h3>Without Toolbar (Markdown Only)</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>Small Size (default)</p>
                <DSRichTextarea
                  dataTestId="ds-test-rich-textarea-small"
                  placeholder="Start typing with markdown support..."
                  value={richTextareaValue}
                  onChange={setRichTextareaValue}
                >
                  <DSRichTextarea.Input />
                </DSRichTextarea>
              </div>
              <div>
                <p>Medium Size</p>
                <DSRichTextarea
                  dataTestId="ds-test-rich-textarea-medium"
                  size="md"
                  placeholder="Start typing with markdown support..."
                  onChange={() => {}}
                >
                  <DSRichTextarea.Input />
                </DSRichTextarea>
              </div>
            </div>
          </div>

          {/* States */}
          <div className="mb-lg">
            <h3>States</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg mb-xl max-w-4xl">
              <div>
                <p>With Error</p>
                <DSRichTextarea
                  dataTestId="ds-test-rich-textarea-error"
                  label="Required Field"
                  placeholder="This field is required..."
                  error="Please enter some content"
                  onChange={() => {}}
                >
                  <DSRichTextarea.Input />
                </DSRichTextarea>
              </div>
              <div>
                <p>Disabled</p>
                <DSRichTextarea
                  dataTestId="ds-test-rich-textarea-disabled"
                  placeholder="This is disabled"
                  disabled
                  value="<p>Some <strong>formatted</strong> text</p>"
                  onChange={() => {}}
                >
                  <DSRichTextarea.Input />
                </DSRichTextarea>
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Checkboxes Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Checkboxes</h2>

        <DSCardWrapper dataTestId="ds-test-checkboxes-card">
          {/* Medium Size */}
          <div className="mb-lg">
            <h3>Medium (default)</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Unchecked</p>
                <DSCheckbox dataTestId="ds-test-checkbox-unchecked" />
              </div>
              <div>
                <p>Checked</p>
                <DSCheckbox
                  dataTestId="ds-test-checkbox-checked"
                  checked
                />
              </div>
              <div>
                <p>Unchecked Disabled</p>
                <DSCheckbox
                  dataTestId="ds-test-checkbox-unchecked-disabled"
                  disabled
                />
              </div>
              <div>
                <p>Checked Disabled</p>
                <DSCheckbox
                  dataTestId="ds-test-checkbox-checked-disabled"
                  checked
                  disabled
                />
              </div>
            </div>
          </div>

          {/* Large Size */}
          <div>
            <h3>Large</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Unchecked</p>
                <DSCheckbox
                  dataTestId="ds-test-checkbox-lg-unchecked"
                  size="md"
                />
              </div>
              <div>
                <p>Checked</p>
                <DSCheckbox
                  dataTestId="ds-test-checkbox-lg-checked"
                  size="md"
                  checked
                />
              </div>
              <div>
                <p>Unchecked Disabled</p>
                <DSCheckbox
                  dataTestId="ds-test-checkbox-lg-unchecked-disabled"
                  size="md"
                  disabled
                />
              </div>
              <div>
                <p>Checked Disabled</p>
                <DSCheckbox
                  dataTestId="ds-test-checkbox-lg-checked-disabled"
                  size="md"
                  checked
                  disabled
                />
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Toggles Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Toggles</h2>

        <DSCardWrapper dataTestId="ds-test-toggles-card">
          {/* Basic Toggles */}
          <div className="mb-lg">
            <h3>Basic</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Off</p>
                <DSToggle dataTestId="ds-test-toggle-off" />
              </div>
              <div>
                <p>On</p>
                <DSToggle dataTestId="ds-test-toggle-on" checked />
              </div>
              <div>
                <p>Off Disabled</p>
                <DSToggle
                  dataTestId="ds-test-toggle-off-disabled"
                  disabled
                />
              </div>
              <div>
                <p>On Disabled</p>
                <DSToggle
                  dataTestId="ds-test-toggle-on-disabled"
                  checked
                  disabled
                />
              </div>
            </div>
          </div>

          {/* Toggles with Icons */}
          <div>
            <h3>With Icons</h3>
            <div className="flex flex-wrap gap-lg items-center mb-xl">
              <div>
                <p>Off (Light Mode)</p>
                <DSToggle
                  dataTestId="ds-test-toggle-icons-off"
                  showIcons
                />
              </div>
              <div>
                <p>On (Dark Mode)</p>
                <DSToggle
                  dataTestId="ds-test-toggle-icons-on"
                  showIcons
                  checked
                />
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Dropdowns Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Dropdowns</h2>

        <DSCardWrapper dataTestId="ds-test-dropdowns-card">
          {/* Basic Dropdown */}
          <div className="mb-lg">
            <h3>Basic</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>Default (md)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-basic"
                  options={dropdownOptions}
                  value={basicDropdownValue}
                  onChange={(value) => setBasicDropdownValue(value)}
                  placeholder="Select an option"
                />
              </div>
              <div>
                <p>Small</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-basic"
                  options={dropdownOptions}
                  value={basicDropdownValue}
                  onChange={(value) => setBasicDropdownValue(value)}
                  placeholder="Select an option"
                  size="sm"
                />
              </div>
            </div>
          </div>
          {/* Dropdown with Label */}
          <div className="mb-lg">
            <h3>With Label</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>Label (md)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-label"
                  options={dropdownOptions}
                  value={basicDropdownValue}
                  onChange={(value) => setBasicDropdownValue(value)}
                  placeholder="Select an option"
                  label="Choose option"
                />
              </div>
              <div>
                <p>Label (sm)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-label-sm"
                  options={dropdownOptions}
                  value={basicDropdownValue}
                  onChange={(value) => setBasicDropdownValue(value)}
                  placeholder="Select an option"
                  label="Choose option"
                  size="sm"
                />
              </div>
              <div>
                <p>Label + Search + Icon</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-label-search-icon"
                  options={dropdownOptions}
                  value={searchDropdownValue}
                  onChange={(value) => setSearchDropdownValue(value)}
                  placeholder="Select an option"
                  label="Team member"
                  search
                  searchPlaceholder="Search options..."
                  leadingIcon={faUser}
                />
              </div>
            </div>
          </div>

          <div className="mb-lg">
            <h3>Disabled</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>Disabled</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-basic"
                  options={dropdownOptions}
                  value={disabledDropdownValue}
                  onChange={(value) =>
                    setDisabledDropdownValue(value)
                  }
                  placeholder="Select an option"
                  disabled
                />
              </div>
              <div>
                <p>Disabled (Small)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-basic"
                  options={dropdownOptions}
                  value={disabledDropdownValue}
                  onChange={(value) =>
                    setDisabledDropdownValue(value)
                  }
                  placeholder="Select an option"
                  size="sm"
                  disabled
                />
              </div>
            </div>
          </div>

          {/* Dropdown with Search */}
          <div className="mb-lg">
            <h3>With Search</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>Searchable</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-search"
                  options={dropdownOptions}
                  value={searchDropdownValue}
                  onChange={(value) => setSearchDropdownValue(value)}
                  placeholder="Select an option"
                  search
                  searchPlaceholder="Search options..."
                />
              </div>
              <div>
                <p>Searchable (small)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-search"
                  options={dropdownOptions}
                  value={searchDropdownValue}
                  onChange={(value) => setSearchDropdownValue(value)}
                  placeholder="Select an option"
                  search
                  searchPlaceholder="Search options..."
                  size="sm"
                />
              </div>
            </div>
          </div>

          {/* Dropdown with Leading Icon */}
          <div className="mb-lg">
            <h3>With Leading Icon</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>With Icon</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-icon"
                  options={dropdownOptions}
                  value={iconDropdownValue}
                  onChange={(value) => setIconDropdownValue(value)}
                  placeholder="Select an option"
                  leadingIcon={faUser}
                />
              </div>
              <div>
                <p>With Icon (small)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-icon-sm"
                  options={dropdownOptions}
                  value={iconDropdownValue}
                  onChange={(value) => setIconDropdownValue(value)}
                  placeholder="Select an option"
                  leadingIcon={faUser}
                  size="sm"
                />
              </div>
            </div>
          </div>

          {/* Dropdown with Sections */}
          <div className="mb-lg">
            <h3>With Sections</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>Sectioned Options</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-sections"
                  options={sectionsDropdownOptions}
                  value={sectionsDropdownValue}
                  onChange={(value) =>
                    setSectionsDropdownValue(value)
                  }
                  placeholder="Select a food"
                />
              </div>
              <div>
                <p>Sectioned Options (small)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-sections-sm"
                  options={sectionsDropdownOptions}
                  value={sectionsDropdownValue}
                  onChange={(value) =>
                    setSectionsDropdownValue(value)
                  }
                  placeholder="Select a food"
                  size="sm"
                />
              </div>
            </div>
          </div>

          {/* Dropdown Widths */}
          <div>
            <h3>Custom Widths</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>Default (w-72 / 288px)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-width-default"
                  options={dropdownOptions}
                  value={widthDropdownValue}
                  onChange={(value) => setWidthDropdownValue(value)}
                  placeholder="Select an option"
                />
              </div>
              <div>
                <p>w-48 (192px)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-width-48"
                  options={dropdownOptions}
                  value={widthDropdownValue}
                  onChange={(value) => setWidthDropdownValue(value)}
                  placeholder="Select an option"
                  width="w-48"
                />
              </div>
              <div>
                <p>w-64 (256px)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-width-64"
                  options={dropdownOptions}
                  value={widthDropdownValue}
                  onChange={(value) => setWidthDropdownValue(value)}
                  placeholder="Select an option"
                  width="w-64"
                />
              </div>
              <div className="w-full">
                <p>w-full (100%)</p>
                <DSDropdown
                  dataTestId="ds-test-dropdown-width-full"
                  options={dropdownOptions}
                  value={widthDropdownValue}
                  onChange={(value) => setWidthDropdownValue(value)}
                  placeholder="Select an option"
                  width="w-full"
                />
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Badges Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Badges</h2>

        <DSCardWrapper dataTestId="ds-test-badges-card">
          {/* Status Display Badges */}
          <div className="mb-lg">
            <h3>Status Display (Non-Interactive)</h3>
            <p className="text-secondary mb-md">
              Use DSBadge for read-only status indicators and labels
              that don&apos;t require user interaction.
            </p>
            <div className="flex flex-wrap gap-md items-center mb-xl">
              <DSBadge
                dataTestId="ds-test-badge-brand"
                variant="brand"
              >
                In Progress
              </DSBadge>
              <DSBadge
                dataTestId="ds-test-badge-green"
                variant="green"
              >
                Review
              </DSBadge>
              <DSBadge
                dataTestId="ds-test-badge-yellow"
                variant="yellow"
              >
                Processing
              </DSBadge>
              <DSBadge dataTestId="ds-test-badge-red" variant="red">
                Failed
              </DSBadge>
              <DSBadge dataTestId="ds-test-badge-blue" variant="blue">
                Exported
              </DSBadge>
              <DSBadge dataTestId="ds-test-badge-cyan" variant="cyan">
                New Recording
              </DSBadge>
            </div>
          </div>

          {/* With Icons */}
          <div className="mb-lg">
            <h3>With Icons</h3>
            <div className="flex flex-wrap gap-md items-center mb-xl">
              <DSBadge
                dataTestId="ds-test-badge-icon-verified"
                variant="green"
                icon={faCheck}
              >
                Verified
              </DSBadge>
              <DSBadge
                dataTestId="ds-test-badge-icon-featured"
                variant="yellow"
                icon={faStar}
              >
                Featured
              </DSBadge>
              <DSBadge
                dataTestId="ds-test-badge-icon-tagged"
                variant="blue"
                icon={faTag}
              >
                Tagged
              </DSBadge>
            </div>
          </div>

          {/* Size Variants */}
          <div>
            <h3>Sizes</h3>
            <div className="flex flex-wrap gap-md items-center">
              <DSBadge
                dataTestId="ds-test-badge-sm"
                size="sm"
                variant="green"
              >
                Small
              </DSBadge>
              <DSBadge
                dataTestId="ds-test-badge-md"
                size="md"
                variant="green"
              >
                Medium
              </DSBadge>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Chips Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Chips</h2>

        <DSCardWrapper dataTestId="ds-test-chips-card">
          {/* Use Case 1: Filter Chips (Dropdown Triggers) */}
          <div className="mb-lg">
            <h3>Filter Chips</h3>
            <p className="text-secondary mb-md">
              Use DSChip for interactive filters that trigger
              dropdowns. Shows label when not applied (with chevron),
              shows value when applied (with X to clear).
            </p>
            <div className="flex flex-wrap gap-md items-center mb-xl">
              <div>
                <p className="mb-sm">Not Applied</p>
                <DSChip
                  dataTestId="ds-test-chip-filter-date"
                  onClick={() => setDateFilterApplied(true)}
                  applied={dateFilterApplied}
                  onDismiss={() => setDateFilterApplied(false)}
                >
                  {dateFilterApplied ? "15/01/24 - 20/01/24" : "Date"}
                </DSChip>
              </div>
              <div>
                <p className="mb-sm">Applied</p>
                <DSChip
                  dataTestId="ds-test-chip-filter-team"
                  onClick={() => alert("Open team selector")}
                  applied={teamFilterApplied}
                  onDismiss={() => setTeamFilterApplied(false)}
                >
                  {teamFilterApplied ? "John Smith" : "My Notes"}
                </DSChip>
              </div>
              <div>
                <p className="mb-sm">Interactive Demo</p>
                <DSChip
                  dataTestId="ds-test-chip-filter-template"
                  onClick={() => setTemplateFilterApplied(true)}
                  applied={templateFilterApplied}
                  onDismiss={() => setTemplateFilterApplied(false)}
                >
                  {templateFilterApplied
                    ? "Consultation"
                    : "Template"}
                </DSChip>
              </div>
            </div>
          </div>

          {/* Use Case 2: Selectable Chips */}
          <div className="mb-lg">
            <h3>Selectable Chips (Tags)</h3>
            <p className="text-secondary mb-md">
              Chips that can be selected and cleared. Click to toggle,
              click X to clear.
            </p>
            <div className="flex flex-wrap gap-md items-center mb-xl">
              <DSChip
                dataTestId="ds-test-chip-selectable-react"
                variant="selectable"
                onClick={() =>
                  setDateFilterApplied(!dateFilterApplied)
                }
                applied={dateFilterApplied}
                onDismiss={() => setDateFilterApplied(false)}
              >
                React
              </DSChip>
              <DSChip
                dataTestId="ds-test-chip-selectable-typescript"
                variant="selectable"
                onClick={() =>
                  setTeamFilterApplied(!teamFilterApplied)
                }
                applied={teamFilterApplied}
                onDismiss={() => setTeamFilterApplied(false)}
              >
                TypeScript
              </DSChip>
              <DSChip
                dataTestId="ds-test-chip-selectable-design"
                variant="selectable"
                onClick={() =>
                  setTemplateFilterApplied(!templateFilterApplied)
                }
                applied={templateFilterApplied}
                onDismiss={() => setTemplateFilterApplied(false)}
              >
                Design Systems
              </DSChip>
            </div>
          </div>

          {/* Disabled State */}
          <div>
            <h3>Disabled State</h3>
            <p className="text-secondary mb-md">
              Chips in disabled state are not interactive
            </p>
            <div className="flex flex-wrap gap-md items-center">
              <DSChip
                dataTestId="ds-test-chip-disabled"
                disabled
                onClick={() => {}}
              >
                Disabled
              </DSChip>
              <DSChip
                dataTestId="ds-test-chip-disabled-applied"
                disabled
                onClick={() => {}}
                applied
                onDismiss={() => {}}
              >
                Disabled Applied
              </DSChip>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Card Wrappers Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Card Wrappers</h2>

        <DSCardWrapper
          dataTestId="ds-test-cards-section"
          variant="ghost"
        >
          {/* Basic Cards */}
          <div className="mb-lg">
            <h3>Basic</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div className="w-96">
                <p>Default</p>
                <DSCardWrapper dataTestId="ds-test-card-default">
                  <h4 className="mb-sm">Card Title</h4>
                  <p className="text-secondary">
                    This is a default card with some content inside.
                  </p>
                </DSCardWrapper>
              </div>
              <div className="w-96">
                <p>Interactive (Hover Me)</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-interactive"
                  interactive
                  onClick={() => alert("Card clicked!")}
                >
                  <h4 className="mb-sm">Clickable Card</h4>
                  <p className="text-secondary">
                    This card has hover effects and is clickable.
                  </p>
                </DSCardWrapper>
              </div>
              <div className="w-96">
                <p>Ghost</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-ghost"
                  variant="ghost"
                >
                  <h4 className="mb-sm">Ghost Card</h4>
                  <p className="text-secondary">
                    This card has a dashed border for placeholder
                    states.
                  </p>
                </DSCardWrapper>
              </div>
            </div>
          </div>

          {/* Card Variants */}
          <div className="mb-lg">
            <h3>Variants</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div className="w-96">
                <p>Default</p>
                <DSCardWrapper dataTestId="ds-test-card-variant-default">
                  <h4 className="mb-sm">Default Card</h4>
                  <p className="text-secondary">
                    Standard card with default styling.
                  </p>
                </DSCardWrapper>
              </div>
              <div className="w-96">
                <p>Info</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-variant-info"
                  variant="info"
                >
                  <h4 className="mb-sm">Info Card</h4>
                  <p className="text-secondary">
                    Use for information or neutral messages.
                  </p>
                </DSCardWrapper>
              </div>
              <div className="w-96">
                <p>Danger</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-variant-danger"
                  variant="danger"
                >
                  <h4 className="mb-sm">Danger Card</h4>
                  <p className="text-secondary">
                    Use for errors or destructive actions.
                  </p>
                </DSCardWrapper>
              </div>
              <div className="w-96">
                <p>Warning</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-variant-warning"
                  variant="warning"
                >
                  <h4 className="mb-sm">Warning Card</h4>
                  <p className="text-secondary">
                    Use for warnings or caution messages.
                  </p>
                </DSCardWrapper>
              </div>
              <div className="w-96">
                <p>Success</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-variant-success"
                  variant="success"
                >
                  <h4 className="mb-sm">Success Card</h4>
                  <p className="text-secondary">
                    Use for success messages or positive feedback.
                  </p>
                </DSCardWrapper>
              </div>
              <div className="w-96">
                <p>Ghost</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-variant-ghost"
                  variant="ghost"
                >
                  <h4 className="mb-sm">Ghost Card</h4>
                  <p className="text-secondary">
                    Use for placeholder or empty states.
                  </p>
                </DSCardWrapper>
              </div>
            </div>
          </div>

          {/* Card Padding */}
          <div>
            <h3>Custom Padding</h3>
            <div className="flex flex-wrap gap-lg items-start mb-xl">
              <div>
                <p>p-sm (8px)</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-padding-sm"
                  width="w-64"
                  padding="p-sm"
                >
                  <h4 className="mb-sm">Small Padding</h4>
                  <p className="text-secondary">Compact card</p>
                </DSCardWrapper>
              </div>
              <div>
                <p>p-md (16px - default)</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-padding-md"
                  width="w-64"
                >
                  <h4 className="mb-sm">Medium Padding</h4>
                  <p className="text-secondary">Default padding</p>
                </DSCardWrapper>
              </div>
              <div>
                <p>p-lg (32px)</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-padding-lg"
                  width="w-64"
                  padding="p-lg"
                >
                  <h4 className="mb-sm">Large Padding</h4>
                  <p className="text-secondary">Spacious card</p>
                </DSCardWrapper>
              </div>
              <div>
                <p>p-0 (no padding)</p>
                <DSCardWrapper
                  dataTestId="ds-test-card-padding-none"
                  width="w-64"
                  padding="p-0"
                >
                  <div className="p-md bg-secondary">
                    <h4 className="mb-sm">No Padding</h4>
                    <p className="text-secondary">
                      Useful for custom layouts
                    </p>
                  </div>
                </DSCardWrapper>
              </div>
            </div>
          </div>
        </DSCardWrapper>
      </section>

      {/* Dropzone Section */}
      <section className="mb-xl">
        <h2 className="mb-lg">Dropzone</h2>

        <DSCardWrapper
          variant="ghost"
          dataTestId="ds-test-dropzone-card"
        >
          {/* Basic Dropzone */}
          <div className="mb-lg">
            <h3>Default</h3>
            <p className="text-secondary mb-md">
              Basic drag and drop file upload area. Click or drag
              files to upload.
            </p>
            <DSDropzone
              dataTestId="ds-test-dropzone-basic"
              onFilesSelected={(files) =>
                alert(`Selected ${files.length} file(s)`)
              }
            />
          </div>

          {/* Multiple Files */}
          <div className="mb-lg">
            <h3>Multiple Files</h3>
            <p className="text-secondary mb-md">
              Allows selecting multiple files at once.
            </p>
            <DSDropzone
              dataTestId="ds-test-dropzone-multiple"
              multiple
              accept="image/*"
              label="Upload images"
              helperText="Select multiple images"
              onFilesSelected={(files) =>
                alert(`Selected ${files.length} image(s)`)
              }
            />
          </div>

          {/* With Progress */}
          <div className="mb-lg">
            <h3>Upload Progress</h3>
            <p className="text-secondary mb-md">
              Shows progress bar during upload. Click to simulate.
            </p>
            <DSDropzone
              dataTestId="ds-test-dropzone-progress"
              uploadProgress={uploadProgress}
              onFilesSelected={() => {
                setUploadProgress(0);
                const interval = setInterval(() => {
                  setUploadProgress((prev) => {
                    if (prev === undefined || prev >= 100) {
                      clearInterval(interval);
                      setTimeout(
                        () => setUploadProgress(undefined),
                        1000,
                      );
                      return 100;
                    }
                    return prev + 10;
                  });
                }, 200);
              }}
            />
          </div>

          {/* Disabled */}
          <div>
            <h3>Disabled</h3>
            <p className="text-secondary mb-md">
              Dropzone in disabled state.
            </p>
            <DSDropzone
              dataTestId="ds-test-dropzone-disabled"
              disabled
            />
          </div>
        </DSCardWrapper>
      </section>
    </>
  );
};
